define("settings/controllers/groups/group/social_profiles/edit", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/controller", "@ember/object", "@ember/service", "ember-concurrency", "later/utils/profile-colors"], function (_exports, _asyncArrowRuntime, _controller, _object, _service, _emberConcurrency, _profileColors) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"ember-concurrency",0,"later/utils/profile-colors"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let EditController = _exports.default = (_class = class EditController extends _controller.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "router", _descriptor4, this);
      _initializerDefineProperty(this, "store", _descriptor5, this);
      _defineProperty(this, "queryParams", ['tab']);
      _defineProperty(this, "availableColors", _profileColors.availableColors);
      _defineProperty(this, "deviceNotifyHelpVisible", false);
      _defineProperty(this, "group", null);
      _defineProperty(this, "selectedSocialProfile", null);
      _defineProperty(this, "saveSocialProfile", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (socialProfile) {
          try {
            yield socialProfile.save();
            this.alerts.clear();
            this.alerts.success(this.intl.t('alerts.linkinbio.successfully_updated'));
            this.closeModal();
          } catch (error) {
            this.errors.handleAdapter(error);
          }
        }
      }), null, "saveSocialProfile", "drop"));
    }
    closeModal() {
      this.router.transitionTo('account.groups.group.social_profiles');
    }
    addRemoveDevice(socialProfile, type, device_id) {
      const device = this.store.peekRecord('device', device_id);
      if (type === 'add') {
        this._addDeviceToProfile(socialProfile, device);
      } else if (type === 'remove') {
        this._removeDeviceFromProfile(socialProfile, device);
      }
    }
    trackChangedProfileColor(socialProfile, colorClass) {
      socialProfile.set('profileColorClass', colorClass);
      socialProfile.save().catch(adapterError => this.errors.handleAdapter(adapterError, socialProfile));
    }
    _addDeviceToProfile(profile, device) {
      profile.get('devices').addObject(device);
    }
    _removeDeviceFromProfile(profile, device) {
      profile.get('devices').removeObject(device);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "closeModal", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addRemoveDevice", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addRemoveDevice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackChangedProfileColor", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackChangedProfileColor"), _class.prototype)), _class);
});